"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreviewProductsWidgetContent = void 0;
var preview_products_widget_content_container_1 = require("./preview-products-widget-content.container");
Object.defineProperty(exports, "PreviewProductsWidgetContent", { enumerable: true, get: function () { return preview_products_widget_content_container_1.PreviewProductsWidgetContent; } });
